import React, {useLayoutEffect,useState,useCallback,useEffect} from 'react';
import { required, email } from 'react-admin';
// import { change } from 'redux-form';
// import { cardActionStyle, sdoStatuses, LineItemsSideComponent } from './common';
import { getLocalStorageKey } from '../common/common';
import myDataProvider from '../myRestProvider';
import Select from 'react-select';

import { RUN_TIME_API_ENDPOINT, CommonHeaderOption, DigitalOrderSystem, EmptyPagination } from '../common/common';

const SalesOfficersCreate = (props) => {
  // constructor(props) {
  //   super(props);
  //   this.state = {
  //     sale_officer: {},
  //     businessesData: [],
  //     showLoader: false,
  //     successMsg: false,
  //     validationError: false,
  //     validationEmailError: false,
  //     validationPhoneError: false,
  //     saveButtonDisabled: true,
  //     errorMsg: false,
  //     errorMsgText: null,
  //     saleOffEmail: '',
  //     saleOffPhone: '',

  //   }
  // }

  const [sale_officer, setSaleOfficer] = useState({});
  const [businessesData, setBusinessData] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [successMsg, setSuccessMsg] = useState(false);
  const [validationError, setValidationError] = useState(false);
  const [validationEmailError, setValidationEmailError] = useState(false);
  const [validationPhoneError, setValidationPhoneError] = useState(false);
  const [saveButtonDisabled, setSaveButtonDisabled] = useState(true);
  const [errorMsg, setErrorMsg] = useState(false);
  const [errorMsgText, setErrorMsgText] = useState(null);
  const [saleOffEmail, setSaleOffEmail] = useState('');
  const [saleOffPhone, setSaleOffPhone] = useState('');
  const [saleOffStatus, setSaleOffStatus] = useState('');

  const [originalList, setOriginalList] = useState([]);
  const [saleOffNameSapCode, setSaleOffNameSapCode] = useState([]);
  const [saleOffList, setSaleOffList] = useState([]);





  useLayoutEffect(() => {
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    options.method = 'GET';
    fetch(`${apiUrl}/so_business_list`, options)
      .then(res => {
        return res.json();
      }).then(jsonD => {
        console.log('jsonD ===>', jsonD)
        let obj = {};
        obj.sap_order_materials = jsonD.data;
        obj.loadingShow = false;
        // console.log('obj==>', obj);
        setSaleOffPhone(obj.sap_order_materials.phone);
        setOriginalList(obj.sap_order_materials.map(item => ({ 'id': item.id, 'value': item.label, 'label': item.label })));
        setSaleOffNameSapCode(obj.sap_order_materials.map(item => ({ 'id': item.id, 'value': item.label, 'label': item.label })));
        
      });
       
  
  }, []);
 
  const handleChange = e => {
    console.log('hiiii', e);
    console.log('saleOffNameSapCode in handleChange', saleOffNameSapCode);
    // console.log('saleOffList', saleOffNameSapCode);
    const arr = [...originalList]

    let result = arr && arr.filter(item => e && e.filter(i => i.id === item.id).length === 0);
    if (e === null) {
      result = [...originalList]
    }
    // console.log('result', result)
    setSaleOffNameSapCode(result);
    setSaleOffList(e);
    
  };

  const handleInputChange = e => {
    setSaleOffNameSapCode(saleOffNameSapCode);
  }

  const emailChange = (e) => {
    console.log('e >>>>>>>>>', e.target.value);
    // if (/.+@.+\.[A-Za-z]+$/.test(e.target.value) === false) {
    if (/([a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3})/.test(e.target.value) === false) {
      setValidationError(true);
      setValidationEmailError(true);
      
    } else {
      setValidationError(false);
      setValidationEmailError(false);
    }
    setSaleOffEmail(e.target.value);

  };

  const phoneChange = (e) => {
    if (/^\d+$/.test(e.target.value) != true) {
      setValidationError(true);
      setValidationPhoneError(true);
    } else {
      setValidationError(false);
      setValidationPhoneError(false);
    }
    setSaleOffPhone(e.target.value);


  };

  const statusChange = (e) => {
    setSaleOffStatus(e.target.value);

  };

  const formSave = () => {
    setShowLoader(true);
    setSaveButtonDisabled(false);
    const formData = {
      email: saleOffEmail,
      phone: saleOffPhone,
      status: saleOffStatus,
      name_sap_code: saleOffList

    }
    console.log('formData>>>>>>', formData);

    const apiUrl = RUN_TIME_API_ENDPOINT;
    const options = CommonHeaderOption();
    options.method = 'POST';
    options.body = JSON.stringify({ formData });
    return fetch(`${apiUrl}/sales_officers`, options)
      .then(res => {
        console.log('res12...........', res)
        if (res) {
          return res.json();
        }
      }
      )
      .then(res => {
        if (res.errorMsg) {
          setErrorMsg(true);
          setShowLoader(false);
          setErrorMsgText(res.errorMsg);
          
          setTimeout(() => {
            setErrorMsg(false);
          setShowLoader(true);
          }, 3000)
        } else {
          console.log('res...........', res)
          
          setShowLoader(false);
          setSaveButtonDisabled(true);
          setSuccessMsg(true);

          setTimeout(() => {
            setSuccessMsg(false);
          }, 2000)
          setTimeout(() => {
            props.history.push("/sales_officers");
          }, 3000)
          console.log('res', res);
        }

      }).catch(error => {
        console.log(error);
      })

  }

  const cancelClick = () => {
    setSaleOffList(null);
    setSaleOffNameSapCode(originalList);
  }

    console.log('state ==>', this.state);
    console.log('saleOffNameSapCode', saleOffNameSapCode);
    return (
      <div className="so-form-container panel-margin-top">
        <div className="so-form">
          <div className="so-input">
            <label>Sales officer Email <sup>*</sup></label>
            <input
              className="form-control"
              type="email"
              name="Email"
              value={saleOffEmail}
              onChange={emailChange}
              validations={[required, email]}
            />
            <div className="valid-emailid">Enter email with Lafarge Holcim business suite. </div>
            {validationEmailError &&
              <p className="so-input-error">Please enter valid email</p>
            }
          </div>

          <div className="so-input">
            <label>Sales officer Phone</label>
            <input
              className="form-control"
              type="text"
              name="Phone"
              maxLength="15"
              value={saleOffPhone}
              onChange={phoneChange}
            // onBlur={this.handleChange}
            />
            {validationPhoneError &&
              <p className="so-input-error">Please enter valid phone number</p>
            }
          </div>

          <label className="select-label">Choose Retailers<sup>*</sup> (Atleast select one retailer)</label>
          <div className="select-retailer">
            <Select
              value={saleOffList}
              onChange={handleChange}
              // onInputChange={this.handleInputChange}
              options={saleOffNameSapCode}
              isMulti
            />
            <button onClick={cancelClick}>Clear</button>
          </div>
        </div>
        {saveButtonDisabled &&
          <div className="so-save-button">
            <button className={(!saleOffEmail || !saleOffList || validationEmailError || !saleOffPhone || validationPhoneError) ? 'disable-save' : ''} disabled={validationEmailError || !saleOffEmail || !saleOffList} onClick={() => formSave()}>Save</button>
          </div>
        }

        {showLoader &&
          <div className="save-loader" />
        }
        {successMsg &&
          <div className="so-updated" >
            Successfully Created </div>
        }
        {errorMsg &&
          <div className="so-email-exist" >
            {errorMsgText}</div>
        }
      </div>
    )
  
}

export default SalesOfficersCreate;